<script>
import options from "./SignupSingleNewsletter.options"
export default options
</script>

<template>
  <article
    class="nyk-signup-single-newsletter"
    :class="`nyk-signup-single-newsletter--${newletterClassName}`">
    <div ref="stepAnnouncerRef" aria-live="assertive" aria-atomic="true" class="nyk-visually-hidden"></div>
    <component
      ref="currentStepComponentFocusRef"
      :is="currentStepName"
      :nextStepCallback="validateInputAndProceed"
      :previousStepCallback="returnToPreviousStep"
      :displayInputError="displayInputError"
      :currentStepTexts="currentStepTexts"
      :hasPreviousStep="hasPreviousStep"
      :resetSignupForm="resetSignupForm"
      :inputCallback="inputCallback"
      :getNamedFieldInputData="getNamedFieldInputData"
      :showFieldErrorMessage="showFieldErrorMessage"
      :stepCounterText="stepCounterText" />
  </article>
</template>
